import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { BannerEffect } from '../../services/appearance/appearance';
import { BannerMotionPreferencesService } from '../../services/appearance/banner-motion-preferences.service';

/** Decorative CSS particles; no frame loop or per-particle timers. */
@Component({ selector: 'app-banner-effect', changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './banner-effect.component.html', styleUrls: ['./banner-effect.component.scss'] })
export class BannerEffectComponent implements AfterViewInit, OnDestroy {
    @Input() effect: BannerEffect = 'none';
    inView = false;
    pageVisible = typeof document === 'undefined' || !document.hidden;
    readonly particles = Array.from({ length: 16 }, (_, index) => ({
        left: (index * 37 + 7) % 100, top: (index * 23 + 13) % 85,
        delay: -(index * 0.71), duration: 7 + index % 5, size: 3 + index % 4,
    }));
    private _observer: IntersectionObserver;
    constructor(private _element: ElementRef<HTMLElement>, private _change: ChangeDetectorRef,
        public motion: BannerMotionPreferencesService) {}
    get running(): boolean { return this.motion.enabled && this.inView && this.pageVisible; }
    ngAfterViewInit(): void {
        if (typeof IntersectionObserver === 'undefined') { this.inView = true; this._change.markForCheck(); return; }
        this._observer = new IntersectionObserver(entries => {
            this.inView = entries.some(entry => entry.isIntersecting);
            this._change.markForCheck();
        });
        this._observer.observe(this._element.nativeElement);
    }
    @HostListener('document:visibilitychange') visibilityChanged(): void {
        this.pageVisible = !document.hidden;
        this._change.markForCheck();
    }
    ngOnDestroy(): void { this._observer?.disconnect(); }
}
